import { t } from "@/i18n";
function submittedAt(solution) {
  const value = String(solution.answerDate || '').replace(' ', 'T');
  if (!value) return 0;
  const withZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}+08:00`;
  return Date.parse(withZone) || 0;
}

export function sortSolutions(solutions) {
  if (!Array.isArray(solutions)) return [];
  return solutions.filter(Boolean).slice().sort((a, b) => {
    // A successfully submitted draft stays first until the server returns its id.
    const pending = Number(Boolean(b._awaitingDetails)) - Number(Boolean(a._awaitingDetails));
    if (pending) return pending;
    const aTime = submittedAt(a);
    const bTime = submittedAt(b);
    if (aTime !== bTime) return bTime - aTime;
    return (Number(b.answerId) || 0) - (Number(a.answerId) || 0);
  });
}

export function isRejectedSolution(solution) {
  return solution.result === 1 || solution.result === 2;
}

export function solutionStatus(solution) {
  return ({
    0: { label: t("待验收"), tone: 'pending' },
    1: { label: t("不通过"), tone: 'rejected' },
    2: { label: t("不通过 · 待完善"), tone: 'rejected' },
    3: { label: t("通过"), tone: 'accepted' },
  })[solution.result] || { label: t("未标注状态"), tone: 'unknown' };
}
